export default "__VITE_ASSET__CiEf3ekN__"